module.exports = __webpack_public_path__ + "static/media/19.1c1f7db4.png";